//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../../store/store';
import { useNav } from '../../../hooks/nav';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import pancakes from '../../../assets/images/pancakes.webp';
import cn from 'classnames';

const CORRECT_ANSWER = '410 kcal';

function Page() {
  const youGuessedCount = useStore((state) => state.youGuessedCount);
  const setYouGuessedCount = useStore((state) => state.setYouGuessedCount);

  const { onNext, onPrev, currentIndex } = useNav();
  const [incorrectAnswer, setIncorrectAnswer] = useState<string | null>(null);
  const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
  const [isCorrectSelected, setIsCorrectSelected] = useState(false);
  const [hasNavigated, setHasNavigated] = useState(false);

  useEffect(() => {
    if (hasNavigated) return;
  
    if (isCorrectSelected) {
      const timer = setTimeout(() => {
        setHasNavigated(true);
        onNext();
      }, 800);
      return () => clearTimeout(timer);
    }
  
    if (incorrectAnswer && showCorrectAnswer) {
      const timer = setTimeout(() => {
        setHasNavigated(true);
        onNext();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isCorrectSelected, incorrectAnswer, showCorrectAnswer, onNext, hasNavigated]);
  
  const handleAnswer = (value: string) => {
    setIncorrectAnswer(null);
    setShowCorrectAnswer(false);
    setIsCorrectSelected(false);

    if (value !== CORRECT_ANSWER) {
      setIncorrectAnswer(value);
      setTimeout(() => setShowCorrectAnswer(true), 600);
      return;
    }

    setYouGuessedCount(youGuessedCount + 1);
    setIsCorrectSelected(true);
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: 'how-many-calories-1',
      answer: value,
    });
  };

  const options = [
    { value: '210 kcal' },
    { value: '360 kcal' },
    { value: CORRECT_ANSWER },
    { value: '560 kcal' },
  ];

  return (
    <div className='page' style={{ gap: 0 }}>
      <div className='wrapper-info'>
        <Title tag='h2' style={{ padding: '0 30px' }}>
          {t('onboarding.howManyCalories.title')}
        </Title>
        <Text className='description' size='m' medium style={{ padding: 0 }}>
          {t('onboarding.howManyCalories.dishes.pancakes')}
        </Text>
        <img src={pancakes} width={308} alt='Pancakes with berries and yogurt' />
      </div>

      <div className='controls'>
        <Check onChange={handleAnswer}>
          {options.map((option) => (
            <Option
              key={option.value}
              value={option.value}
              className={cn({
                'incorrect-answer': incorrectAnswer === option.value,
                'correct-answer':
                  (showCorrectAnswer || isCorrectSelected) && option.value === CORRECT_ANSWER,
              })}
            >
              {option.value}
            </Option>
          ))}
        </Check>
      </div>
    </div>
  );
}

export default Page;
